var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VProgressLinear',{class:['training-timer', `${_vm.color}--text`],attrs:{"color":_vm.color,"background-opacity":"0","value":_vm.progress}},[_vm._v(" "+_vm._s(_vm.$t('left.one'))+": "),_c('time',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }